import * as angular from "angular";
import {ThreePlExtraData} from "../../threePL/models/threepl-extra-data.model";
import {FulfillmentStepFilterPayloadModel} from "../models/fulfillment-step-filter-payload.model";
import {CancellationReason} from "../../cancellation-reasons/models/cancellationReason.model";
import {SuperSearchSortMethodType} from "../../search/types/super-search-sort-method.type";

export class FulfillmentStepRequestsService {

  /* @ngInject */
  constructor(private StepsAPI, private $steps, private FulfillmentStepAPI) {
  }

  getStepsByQuery(fulfillmentStepFilterPayloadModel: FulfillmentStepFilterPayloadModel, searchTerm?: string) {
    const api = this.StepsAPI.actions.getStepsByQuery;
    return this.$$call(api, {}, {stepFilter: fulfillmentStepFilterPayloadModel, searchTerm: searchTerm}, {});
  }

  dispatchConsolidate(containerDetails: ThreePlExtraData, query) {
    const api = this.StepsAPI.actions.createTrainVoucher;
    return this.$$call(api, query, containerDetails, {});
  }

  manualHandleAttempt(payload) {
    const api = this.StepsAPI.actions.manualHandleAttempt;
    return this.$$call(api, {}, payload, {});
  }

  // cancelAttempt(ids, cancellationReason: CancellationReason) {
  //   const api = this.StepsAPI.actions.cancelAttempt;
  //   return this.$$call(api, {stepIds: ids}, {cancellationRequest: cancellationReason}, {});
  // }

  cancelAttempt(payload) {
    const api = this.StepsAPI.actions.cancelAttempt;
    return this.$$call(api, {}, payload, {});
  }

  cancelSteps(ids) {
    const api = this.StepsAPI.actions.cancel;
    return this.$$call(api, {stepIds: ids}, {}, {});
  }

  getGlobalSearch(query: string, limit: number = 10, autoComplete: boolean = true, sortMethod?: SuperSearchSortMethodType) {
    const api = this.StepsAPI.actions.getGlobalSearch;
    return this.$$call(api, {query: query, limit: limit, autoComplete: autoComplete, sortMethod: sortMethod}, {}, {});
  }

  getFulfillmentStepSettings(stepIds: string[]) {
    const api = this.StepsAPI.actions.getFulfillmentStepSettings;
    return this.$$call(api, {}, stepIds, {});
  }

  // ******************************
  //        Private methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$steps().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .service('fulfillmentStepRequestsService', FulfillmentStepRequestsService);
